import { getString } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

export const basic = {
  props: {
    label: [ String, Number, Boolean ],
    tooltip: [ String, Number, Boolean ],

    outline: Boolean
  },

  computed: {
    $_attrs() {
      let ariaChecked = 'mixed'
      if (typeof this.proxy === 'boolean') {
        ariaChecked = `${this.proxy}`
      }

      return {
        role: 'checkbox',
        'aria-checked': ariaChecked
      }
    },

    $_label() {
      if (this.label) {
        return getString(this.label)
      }
    },

    $_directives() {
      const result = []
      if (this.tooltip) {
        result.push({
          name: components.tooltip,
          options: { value: this.tooltip || this.$_label }
        })
      }

      return result
    },

    $_on() {
      return {
        click: () => {
          this.toggle()
        }
      }
    }
  }
}
